// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/fonts/ADLaMDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./components/fonts/PublicSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.scrollable::-webkit-scrollbar-track {
  background-color: inherit !important; /* Inherit the background color of the track */
}

.gradient-background {
  /* height: 100vh; */
  background: linear-gradient(to bottom, #2E335A, #1C1B33);
  /* display: flex;
  justify-content: center;
  align-items: center; */
  color: white;
}
@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.margin-top-20 {
  margin-top: 20px;
}

::-webkit-scrollbar {
  width: 4px;   /* vertical */
  height: 4px;
}

::-webkit-scrollbar-thumb {
  background: #ECEDF8;
  border-radius: 10px;
  min-height: 10px;
}

::-webkit-scrollbar-track {
  background: #494B79;
  border-radius: 10px;
  background-clip: content-box;
  padding: 20px 0;
}

.App-link {
  color: #61dafb;
}

.textField {
  background-color: transparent;
  border-radius: 4px;
  color: #b3b0c1;
}

.textField .MuiOutlinedInput-notchedOutline,
.textField:hover .MuiOutlinedInput-notchedOutline,
.textField.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}
.css-bgr7de-MuiPaper-root-MuiAccordion-root {
  gap: 0px !important;
}
.css-yfrx4k-MuiAccordionSummary-content.Mui-expanded {
  margin: 0px !important;
}
.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
  height: 22px !important;
}
.textField .MuiInputBase-input {
  color: #ffffff;
}

.textField .MuiInputLabel-root,
.textField .MuiInputLabel-root.Mui-focused,
.textField .MuiInputLabel-root.Mui-disabled {
  color: #b3b0c1;
}
.selectField {
  background-color: #2b2a3c; /* Dark gray background */
  border-radius: 4px;
  color: #b3b0c1;
}

.selectField .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}

.selectField:hover .MuiOutlinedInput-notchedOutline,
.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #ffffff; 
}

.selectField .MuiInputBase-input {
  color: #ffffff;
}

.selectField .MuiInputLabel-root {
  color: #b3b0c1;
}

.selectField .MuiInputLabel-root.Mui-focused {
  color: #ffffff;
}

.selectField .MuiSelect-icon {
  color: #b3b0c1; 
}

.selectField .MuiMenuItem-root {
  color: #ffffff; 
  background-color: #2b2a3c;
}

.selectField .MuiMenuItem-root:hover {
  background-color: #383750; 
}
/*select  */
.selectField {
  color: #b3b0c1;
}

.selectField .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}

.selectField:hover .MuiOutlinedInput-notchedOutline,
.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}

.selectField .MuiSelect-icon {
  color: #b3b0c1;
}
/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper.css-6odml8-MuiPaper-root-MuiPopover-paper-MuiMenu-paper{
  background-color: #2b2a3c;
} */
.countContainer{
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  justify-content: space-between;
  gap: 10px;
}
.buttonContainer{
  display: flex;
  justify-content: space-between;
  gap: 5px;
  margin: 5px 5px;
}
.MuiTypography-root.countText{
  color: #b3b0c1;
  margin-left: 20px;
}
/* prompt */
.promptContainer{
  display: flex;
  gap: 5px;
  align-items: center;
}
.MuiTypography-root.showcaseDescription{
  font-size: 16px;
  font-weight: 400;
  font-family: var(--font-family-primary);
  color: #ffffff;
  margin-bottom: 10px;
}
.MuiTypography-root.showcaseTitle{
  font-size: 18px;
  font-weight: 400;
  font-family: var(--font-family-primary);
  color: #ffffff;
}
.MuiTypography-root.showcaseSubTitle{
  font-size: 18px;
  font-weight: 400;
  font-family: var(--font-family-primary);
  color: #ffffff;
}
.MuiTypography-root.showcaseSubDescription{
  font-size: 16px;
  font-weight: 400;
  font-family: var(--font-family-primary);
  color: #ffffff;
  text-transform: none;
}
.MuiTypography-root.showcaseSubDescriptionItalic{
  font-size: 16px;
  font-weight: 400;
  font-family: var(--font-family-primary);
  color: #B8B9C8;
  text-transform: none;
  font-style: italic;
}
.MuiGrid-root:focus-visible{
  outline: none;
  border: none;
}
div:focus-visible{
  outline: none;
  border: none;
}
.MuiBox-root:focus-visible{
  outline: none;
  border: none;
}
.MuiTypography-root.errorText{
  font-size: 14px;
  font-weight: 400;
  font-family: var(--font-family-primary);
  color: #FF5B5E;
  margin-top: 5px;
  margin-bottom: 5px;
}
.showcasalogo{
    width: 158px;
    height: 30px;
}

/* media query */
@media screen and (min-width: 768px) {
 .MuiTypography-root.showcaseTitle{
  font-size: 24px;
}
  .App-header {
    font-size: calc(8px + 2vmin);
  }
  
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.MuiBox-root.position-sticky {
  position: sticky;
  top: 0;
  z-index: 10;
  background:#292B49;
}
.MuiBox-root.backgroundColor-2D3157 {
  background:#2D3157;
}

/* fonts */
/* Import Google Font */

/* Custom Font */
@font-face {
  font-family: 'ADLaM Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
    font-family: 'Public Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oCAAoC,EAAE,8CAA8C;AACtF;;AAEA;EACE,mBAAmB;EACnB,wDAAwD;EACxD;;wBAEsB;EACtB,YAAY;AACd;AACA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU,IAAI,aAAa;EAC3B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;AACA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA,WAAW;AACX;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;;GAEG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA,gBAAgB;AAChB;CACC;EACC,eAAe;AACjB;EACE;IACE,4BAA4B;EAC9B;;AAEF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA,UAAU;AACV,uBAAuB;;AAGvB,gBAAgB;AAChB;EACE,4BAA4B;EAC5B,+DAA0E;EAC1E,mBAAmB;EACnB,kBAAkB;AACpB;AACA;IACI,0BAA0B;IAC1B,+DAAsE;IACtE,mBAAmB;IACnB,kBAAkB;EACpB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.scrollable::-webkit-scrollbar-track {\n  background-color: inherit !important; /* Inherit the background color of the track */\n}\n\n.gradient-background {\n  /* height: 100vh; */\n  background: linear-gradient(to bottom, #2E335A, #1C1B33);\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  color: white;\n}\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.margin-top-20 {\n  margin-top: 20px;\n}\n\n::-webkit-scrollbar {\n  width: 4px;   /* vertical */\n  height: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #ECEDF8;\n  border-radius: 10px;\n  min-height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #494B79;\n  border-radius: 10px;\n  background-clip: content-box;\n  padding: 20px 0;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.textField {\n  background-color: transparent;\n  border-radius: 4px;\n  color: #b3b0c1;\n}\n\n.textField .MuiOutlinedInput-notchedOutline,\n.textField:hover .MuiOutlinedInput-notchedOutline,\n.textField.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n.css-bgr7de-MuiPaper-root-MuiAccordion-root {\n  gap: 0px !important;\n}\n.css-yfrx4k-MuiAccordionSummary-content.Mui-expanded {\n  margin: 0px !important;\n}\n.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {\n  height: 22px !important;\n}\n.textField .MuiInputBase-input {\n  color: #ffffff;\n}\n\n.textField .MuiInputLabel-root,\n.textField .MuiInputLabel-root.Mui-focused,\n.textField .MuiInputLabel-root.Mui-disabled {\n  color: #b3b0c1;\n}\n.selectField {\n  background-color: #2b2a3c; /* Dark gray background */\n  border-radius: 4px;\n  color: #b3b0c1;\n}\n\n.selectField .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n\n.selectField:hover .MuiOutlinedInput-notchedOutline,\n.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #ffffff; \n}\n\n.selectField .MuiInputBase-input {\n  color: #ffffff;\n}\n\n.selectField .MuiInputLabel-root {\n  color: #b3b0c1;\n}\n\n.selectField .MuiInputLabel-root.Mui-focused {\n  color: #ffffff;\n}\n\n.selectField .MuiSelect-icon {\n  color: #b3b0c1; \n}\n\n.selectField .MuiMenuItem-root {\n  color: #ffffff; \n  background-color: #2b2a3c;\n}\n\n.selectField .MuiMenuItem-root:hover {\n  background-color: #383750; \n}\n/*select  */\n.selectField {\n  color: #b3b0c1;\n}\n\n.selectField .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n\n.selectField:hover .MuiOutlinedInput-notchedOutline,\n.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n\n.selectField .MuiSelect-icon {\n  color: #b3b0c1;\n}\n/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper.css-6odml8-MuiPaper-root-MuiPopover-paper-MuiMenu-paper{\n  background-color: #2b2a3c;\n} */\n.countContainer{\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n  justify-content: space-between;\n  gap: 10px;\n}\n.buttonContainer{\n  display: flex;\n  justify-content: space-between;\n  gap: 5px;\n  margin: 5px 5px;\n}\n.MuiTypography-root.countText{\n  color: #b3b0c1;\n  margin-left: 20px;\n}\n/* prompt */\n.promptContainer{\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n.MuiTypography-root.showcaseDescription{\n  font-size: 16px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n  color: #ffffff;\n  margin-bottom: 10px;\n}\n.MuiTypography-root.showcaseTitle{\n  font-size: 18px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n  color: #ffffff;\n}\n.MuiTypography-root.showcaseSubTitle{\n  font-size: 18px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n  color: #ffffff;\n}\n.MuiTypography-root.showcaseSubDescription{\n  font-size: 16px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n  color: #ffffff;\n  text-transform: none;\n}\n.MuiTypography-root.showcaseSubDescriptionItalic{\n  font-size: 16px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n  color: #B8B9C8;\n  text-transform: none;\n  font-style: italic;\n}\n.MuiGrid-root:focus-visible{\n  outline: none;\n  border: none;\n}\ndiv:focus-visible{\n  outline: none;\n  border: none;\n}\n.MuiBox-root:focus-visible{\n  outline: none;\n  border: none;\n}\n.MuiTypography-root.errorText{\n  font-size: 14px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n  color: #FF5B5E;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.showcasalogo{\n    width: 158px;\n    height: 30px;\n}\n\n/* media query */\n@media screen and (min-width: 768px) {\n .MuiTypography-root.showcaseTitle{\n  font-size: 24px;\n}\n  .App-header {\n    font-size: calc(8px + 2vmin);\n  }\n  \n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.MuiBox-root.position-sticky {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background:#292B49;\n}\n.MuiBox-root.backgroundColor-2D3157 {\n  background:#2D3157;\n}\n\n/* fonts */\n/* Import Google Font */\n@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;700&display=swap');\n\n/* Custom Font */\n@font-face {\n  font-family: 'ADLaM Display';\n  src: url('./components/fonts/ADLaMDisplay-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n    font-family: 'Public Sans';\n    src: url('./components/fonts/PublicSans-Light.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
